import StatusSelector from "components/base/StatusSelector";
import useSavePackaging from "../../useSavePacking";

const DesignersView = ({ pkg, disabled }) => {
  const { state, onChange } = useSavePackaging(
    pkg.id,
    "design",
    JSON.parse(pkg.design),
  );

  return (
    <div className="-mx-2 mt-4">
      <table>
        <tbody>
          <tr>
            <td className="text-orange-500 font-semibold">Cherry / Chrissie</td>
            <td></td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Packaging Structure (die-cut):</td>
            <td className="text-right">
              <StatusSelector
                disabled={disabled}
                value={state.dieCutStatus}
                onChange={(e) =>
                  onChange("dieCutStatus", e.target.value, false)
                }
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Packaging artwork:</td>
            <td className="text-right">
              <StatusSelector
                disabled={disabled}
                value={state.artworkStatus}
                onChange={(e) =>
                  onChange("artworkStatus", e.target.value, false)
                }
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Assembling test:</td>
            <td className="text-right">
              <StatusSelector
                disabled={disabled}
                value={state.assemblingTestStatus}
                onChange={(e) =>
                  onChange("assemblingTestStatus", e.target.value, false)
                }
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Packaging drop test:</td>
            <td className="text-right">
              <StatusSelector
                disabled={disabled}
                value={state.packagingDropTestStatus}
                onChange={(e) =>
                  onChange("packagingDropTestStatus", e.target.value, false)
                }
              />
            </td>
          </tr>

          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Initial Packaging Samples Sent:</td>
            <td className="text-right">
              <input
                type="checkbox"
                disabled={disabled}
                checked={state.initialPackagingSamplesSent || false}
                onChange={(e) =>
                  onChange(
                    "initialPackagingSamplesSent",
                    e.target.checked,
                    false,
                  )
                }
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Final Packaging Samples Sent:</td>
            <td className="text-right">
              <input
                type="checkbox"
                disabled={disabled}
                checked={state.finasPackagingSamplesSent || false}
                onChange={(e) =>
                  onChange("finasPackagingSamplesSent", e.target.checked, false)
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default DesignersView;
